import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { APPLICATION } from 'sh-www/models/application';
import { EMBER_ROUTE_NAMES } from 'sh-www/constants/routes';
import { getProjectDetailsIncludes } from 'sh-www/constants/routes/project-details';

const APPLICATION_STATES_TO_SHOW_DECLINE_REMINDER = [
  APPLICATION.STATUS.ACTIVE,
  APPLICATION.STATUS.COMPLETE_PUBLISHER,
  APPLICATION.STATUS.COMPLETE_PUBLISHER,
  APPLICATION.STATUS.COMPLETED,
];

class ProjectDetailsRoute extends Route {
  @service router;
  @service session;

  model(params) {
    return this.controllerFor('project-details').silentlyLoadApplication(
      params.projectIdOrSlug,
      getProjectDetailsIncludes(this.session.currentUser),
    );
  }

  redirect(application) {
    if (!application.pitch) {
      // no pitch on app, send to activity page
      this.router.replaceWith(EMBER_ROUTE_NAMES.PROJECT__DETAILS__ACTIVITY);
    }
  }

  setupController(controller, application, transition) {
    super.setupController(...arguments);

    const isShowingDeclineReminder = !application.pitch?.id
      && application.assignment.pendingApplicationCount
      && APPLICATION_STATES_TO_SHOW_DECLINE_REMINDER.includes(application.status);

    const applicationController = this.controllerFor('application');

    controller.setProperties({ application, isShowingDeclineReminder, applicationController });

    if (transition.data.errors) {
      controller.set('incomingErrors', transition.data.errors);
    }

    controller.refreshApplicationTask.perform(application);
    controller.loadThreadData.perform(application);
    controller.loadPaymentData.perform(application);
    controller.loadFilesData.perform(application);
    if(application.pitch){
      controller.loadPitchData.perform(application);
    }
  }

  resetController(controller, isExiting) {
    super.resetController(...arguments);

    if (isExiting) {
      controller.loadApplicationTask.cancelAll({ resetState: true });
      controller.refreshApplicationTask.cancelAll({ resetState: true });
      controller.loadThreadData.cancelAll({ resetState: true });
      controller.loadPaymentData.cancelAll({ resetState: true });
      controller.loadPitchData.cancelAll({ resetState: true });
      controller.loadFilesData.cancelAll({ resetState: true });
      controller.resetProperties();
    }
  }

  deactivate() {
    super.deactivate(...arguments);
    this.controllerFor('project-details').handleProfileOverlayClose();
  }
}

export default ProjectDetailsRoute;
